"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "formatISOLocalDate", {
  enumerable: true,
  get: function get() {
    return _dateFormatters.formatISOLocalDate;
  }
});
Object.defineProperty(exports, "formatDisplayLocalDate", {
  enumerable: true,
  get: function get() {
    return _dateFormatters.formatDisplayLocalDate;
  }
});
Object.defineProperty(exports, "formatMoney", {
  enumerable: true,
  get: function get() {
    return _numericFormatters.formatMoney;
  }
});
Object.defineProperty(exports, "formatPercentage", {
  enumerable: true,
  get: function get() {
    return _numericFormatters.formatPercentage;
  }
});
Object.defineProperty(exports, "formatPhoneNumber", {
  enumerable: true,
  get: function get() {
    return _numericFormatters.formatPhoneNumber;
  }
});
Object.defineProperty(exports, "useDebounce", {
  enumerable: true,
  get: function get() {
    return _hooks.useDebounce;
  }
});
Object.defineProperty(exports, "featureCheck", {
  enumerable: true,
  get: function get() {
    return _featureChecks["default"];
  }
});
exports.userAgentUtil = exports.numericFormatter = exports.numberUtil = exports.loanUtil = exports.dateFormatter = exports.dateUtil = exports.achUtil = exports.abTest = void 0;

var _aBTest = require("./a-b-test");

var _achUtil = require("./ach-util");

var _dateFormatters = require("./date-formatters");

var _dateUtil = require("./date-util");

var _loanUtil = require("./loan-util");

var _numberUtil = require("./number-util");

var _numericFormatters = require("./numeric-formatters");

var _userAgentUtil = require("./user-agent-util");

var _hooks = require("./hooks");

var _featureChecks = _interopRequireDefault(require("./feature-checks"));

/**
 * @deprecated Moved to numericFormatter
 */

/**
 * @deprecated Moved to dateFormatter
 */
var abTest = {
  getAbVersion: _aBTest.getAbVersion
};
exports.abTest = abTest;
var achUtil = {
  isValidRoutingNumber: _achUtil.isValidRoutingNumber
};
exports.achUtil = achUtil;
var dateUtil = {
  dateFromDisplayFormat: _dateUtil.dateFromDisplayFormat,
  dateFromDefaultFormat: _dateUtil.dateFromDefaultFormat,
  dateIsValid: _dateUtil.dateIsValid,
  isEighteen: _dateUtil.isEighteen,
  isFiftyNineHalf: _dateUtil.isFiftyNineHalf,
  isAtLeast1900: _dateUtil.isAtLeast1900,
  toTz: _dateUtil.toTz
};
exports.dateUtil = dateUtil;
var dateFormatter = {
  formatISOLocalDate: _dateFormatters.formatISOLocalDate,
  formatDisplayLocalDate: _dateFormatters.formatDisplayLocalDate
};
exports.dateFormatter = dateFormatter;
var loanUtil = {
  amortizingLoanPayment: _loanUtil.amortizingLoanPayment,
  getDrawAmountFromTotal: _loanUtil.getDrawAmountFromTotal,
  getDrawAmountFromTotalFloor: _loanUtil.getDrawAmountFromTotalFloor,
  getTotalAmountFromDraw: _loanUtil.getTotalAmountFromDraw,
  getTotalAmountFromDrawRounded: _loanUtil.getTotalAmountFromDrawRounded
};
exports.loanUtil = loanUtil;
var numberUtil = {
  roundUpToMultiple: _numberUtil.roundUpToMultiple,
  roundDownToMultiple: _numberUtil.roundDownToMultiple
};
exports.numberUtil = numberUtil;
var numericFormatter = {
  formatMoney: _numericFormatters.formatMoney,
  formatPercentage: _numericFormatters.formatPercentage,
  formatPhoneNumber: _numericFormatters.formatPhoneNumber
};
exports.numericFormatter = numericFormatter;
var userAgentUtil = {
  isMobileDevice: _userAgentUtil.isMobileDevice
};
exports.userAgentUtil = userAgentUtil;